import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "../../../../../../../common/element/Dialog";
import BtnPrimary from "../../../../../../../common/element/Buttons/btnPrimary";
import ThreeDotLoader from "../../../../../../../common/element/ButtonLoader/ThreeDotLoader";
import SweetAlertService from "../../../../../../../common/SweetAlert/SweetAlert";
import Select from "../../../../../../../common/element/Select"; // Imported Select
import { updateCompanyHR, clearUpdateCompanyHR, getCompanyById } from "../../../../../../../redux/Companies/companiesSlice";
import {
  selectUpdateCompanyHRData,
  selectUpdateCompanyHRLoading,
  selectUpdateCompanyHRError,
} from "../../../../../../../redux/Companies/companiesSelector";
import { useLocation } from "react-router-dom";

const EditHrInfoModal = ({ dialogOpen, onDialogClose, hrData, onSuccess ,companyData }) => {
  console.log(companyData ,"companyDatacompanyData")
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const companyId = searchParams.get('companyId');

  const [formData, setFormData] = useState({
    hrName: "",
    hrEmail: "",
    hrNumber: "",
    hrGender: "", // Added gender state
  });

  const [errors, setErrors] = useState({
    hrName: "",
    hrEmail: "",
    hrNumber: "",
    hrGender: "", // Added gender error state
  });

  // Gender Options
  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "other", label: "Other" }
  ];

  // Helper to find option object based on string value
  const findOptionByValue = (options, value) => {
    if (!value) return null;
    return options.find(option => option.value.toLowerCase() === value.toLowerCase()) || null;
  };

  // Redux selectors
  const updateHRData = useSelector(selectUpdateCompanyHRData);
  const updateHRLoading = useSelector(selectUpdateCompanyHRLoading);
  const updateHRError = useSelector(selectUpdateCompanyHRError);
console.log(hrData ,"hrDatahrData")
  // Pre-fill data when modal opens
  useEffect(() => {
    if (hrData) {
      setFormData({
        hrName: hrData?.first_name + " " + hrData?.last_name || "",
        hrEmail: hrData?.email || "",
        hrNumber: hrData?.mobile_number || "",
        // Pre-fill gender logic
        hrGender: findOptionByValue(genderOptions, companyData?.hr_gender) || "", 
      });
    }
    setErrors({
      hrName: "",
      hrEmail: "",
      hrNumber: "",
      hrGender: "",
    });
  }, [hrData, dialogOpen]);

  // Handle successful update
  useEffect(() => {
    if (updateHRData && !updateHRLoading) {
      setTimeout(() => {
        SweetAlertService.showSuccess({
          title: "Success!",
          message: updateHRData?.message || "HR information updated successfully",
          onConfirm: () => {
            // Clear update state
            dispatch(clearUpdateCompanyHR());
            dispatch(getCompanyById(companyId));

            // Call onSuccess callback if provided
            if (onSuccess) {
              onSuccess(updateHRData);
            }

            // Close dialog
            onDialogClose();
          },
        });
      }, 200);
    }
  }, [updateHRData, updateHRLoading, dispatch, onSuccess, onDialogClose]);

  // Handle update error
  useEffect(() => {
    if (updateHRError) {
      SweetAlertService.showError({
        title: "Error!",
        message: updateHRError || "Failed to update HR information",
      });
      // Clear error after showing
      dispatch(clearUpdateCompanyHR());
    }
  }, [updateHRError, dispatch]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const validate = () => {
    let valid = true;
    let newErrors = {
      hrName: "",
      hrEmail: "",
      hrNumber: "",
      hrGender: "",
    };

    // Validate HR Name
    if (!formData.hrName.trim()) {
      newErrors.hrName = "HR Name is required";
      valid = false;
    }

    // Validate HR Email
    if (!formData.hrEmail.trim()) {
      newErrors.hrEmail = "HR Email is required";
      valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.hrEmail)) {
      newErrors.hrEmail = "Please enter a valid email address";
      valid = false;
    }

    // Validate HR Number
    if (!formData.hrNumber.trim()) {
      newErrors.hrNumber = "HR Number is required";
      valid = false;
    } else if (!/^[+]?[\d\s-()]+$/.test(formData.hrNumber)) {
      newErrors.hrNumber = "Please enter a valid phone number";
      valid = false;
    }

    // Validate Gender
    if (!formData.hrGender) {
      newErrors.hrGender = "Gender is required";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = () => {
    if (!validate()) return;

    // Split hrName into first_name and last_name
    const nameParts = formData.hrName.trim().split(" ");
    const firstName = nameParts[0] || "";
    const lastName = nameParts.slice(1).join(" ") || "";

    // Prepare payload according to API specification
    const payload = {
      first_name: firstName,
      last_name: lastName,
      email: formData.hrEmail.trim(),
      mobile_number: formData.hrNumber.trim(),
      gender: formData.hrGender?.value || "", // Extract value from Select object
    };

    // Dispatch update action
    dispatch(
      updateCompanyHR({
        companyId: companyId,
        hrData: payload,
      })
    );
  };

  const handleClose = () => {
    // Clear any errors when closing
    dispatch(clearUpdateCompanyHR());
    onDialogClose();
  };

  return (
    <Dialog
      isOpen={dialogOpen}
      onClose={handleClose}
      width={800}
      onRequestClose={handleClose}
      bodyOpenClassName="overflow-hidden"
    >
      {/* Header */}
      <div className="flex border-b mb-5 pb-5 px-6 pt-6 items-center justify-between">
        <div className="flex items-center">
          <span className="h-8 w-8 border rounded-lg border-gray-200 flex items-center justify-center shadow-sm mr-4">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
                stroke="#344054"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14 2V8H20M16 13H8M16 17H8M10 9H8"
                stroke="#344054"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <h5 className="mb-0 text-gray-900 text-base font-semibold">
            Edit HR Info
          </h5>
        </div>
        <button
          onClick={handleClose}
          className="text-gray-400 hover:text-gray-600"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6l12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      {/* Body */}
      <div className="px-6 pb-5 space-y-5">
        {/* HR Name */}
        <div className="flex items-center gap-4">
          <label className="w-32 text-sm font-medium text-gray-700">
            HR Name*
          </label>
          <div className="flex-1">
            <input
              className="h-9 pl-3 w-full input input-shadow text-sm border-gray-300 rounded-lg focus:outline-none"
              value={formData.hrName}
              placeholder="Enter HR name here"
              onChange={(e) => handleChange("hrName", e.target.value)}
            />
            {errors.hrName && (
              <p className="text-xs text-red-600 mt-1">{errors.hrName}</p>
            )}
          </div>
        </div>

        {/* HR Email */}
        <div className="flex items-center gap-4">
          <label className="w-32 text-sm font-medium text-gray-700">
            HR Email*
          </label>
          <div className="flex-1">
            <input
              className="h-9 pl-3 w-full input input-shadow text-sm border-gray-300 rounded-lg focus:outline-none"
              value={formData.hrEmail}
              placeholder="Enter HR Email here"
              onChange={(e) => handleChange("hrEmail", e.target.value)}
              type="email"
            />
            {errors.hrEmail && (
              <p className="text-xs text-red-600 mt-1">{errors.hrEmail}</p>
            )}
          </div>
        </div>

        {/* HR Number */}
        <div className="flex items-center gap-4">
          <label className="w-32 text-sm font-medium text-gray-700">
            HR Number*
          </label>
          <div className="flex-1">
            <input
              className="h-9 pl-3 w-full input input-shadow text-sm border-gray-300 rounded-lg focus:outline-none"
              value={formData.hrNumber}
              placeholder="Enter HR number here"
              onChange={(e) => handleChange("hrNumber", e.target.value)}
              type="tel"
            />
            {errors.hrNumber && (
              <p className="text-xs text-red-600 mt-1">{errors.hrNumber}</p>
            )}
          </div>
        </div>

        {/* HR Gender - ADDED FIELD */}
        <div className="flex items-center gap-4">
          <label className="w-32 text-sm font-medium text-gray-700">
            Gender*
          </label>
          <div className="flex-1">
            <Select
              options={genderOptions}
              value={formData.hrGender}
              onChange={(option) => handleChange("hrGender", option)}
              placeholder="Select Gender"
            />
            {errors.hrGender && (
              <p className="text-xs text-red-600 mt-1">{errors.hrGender}</p>
            )}
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="flex dailog-footer">
        <button
          className="mr-1.5 whiteBtnShadow btn border border-gray-100 block w-full rounded-lg h-10 bg-white text-gray-700 text-sm font-semibold hover:bg-gray-50"
          onClick={handleClose}
          style={{ backgroundColor: "#FFF4E5" }}
          disabled={updateHRLoading}
        >
          Cancel
        </button>

        <BtnPrimary
          disabled={updateHRLoading}
          onClick={handleSubmit}
          className="ml-1.5"
          style={{ backgroundColor: "#FF8E1C", borderColor: "#FF8E1C" }}
        >
          {updateHRLoading ? <ThreeDotLoader /> : "Update HR Information"}
        </BtnPrimary>
      </div>
    </Dialog>
  );
};

export default EditHrInfoModal;